import clsx from 'clsx'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import type { AddCartModalProps } from './type'

import { Button, Dialog, ErrorMessageList } from '@/components/ui'
import { CART_TITLE } from '@/const'

const Row = ({
  title,
  value,
  unit,
}: {
  title: string
  value: string
  unit: string
}) => {
  return (
    <li className={clsx('tw-flex tw-items-center tw-justify-between')}>
      <p className={clsx('tw-text-xs tw-font-bold')}>{title}</p>
      <p className={clsx('tw-flex tw-items-baseline tw-gap-1', 'tw-font-bold')}>
        <span className={clsx('tw-text-2xl')}>{value}</span>
        <span className={clsx('tw-text-xs')}>{unit}</span>
      </p>
    </li>
  )
}

export const AddCartModal = ({
  isOpen = false,
  count,
  amount,
  disabledAddCart,
  isLoading,
  errorMessages = [],
  onClose,
  onAddCart,
}: AddCartModalProps) => {
  const { t } = useTranslation()
  const addCardButtonRef = useRef(null)

  return (
    <Dialog
      title={`${t('cart.item.add')}`}
      isOpen={isOpen}
      initialFocus={addCardButtonRef}
    >
      <div className={clsx('tw-mt-2 tw-px-2 tw-pb-4')}>
        {errorMessages.length > 0 && (
          <div className={clsx('tw-mb-2 tw-text-center')}>
            <ErrorMessageList errorMessages={errorMessages} />
          </div>
        )}

        <p className={clsx('tw-text-center tw-text-sm')}>
          {t('cart.item.add_description', { cart: CART_TITLE })}
        </p>

        <ul
          className={clsx(
            'tw-mt-7 tw-inline-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded tw-bg-primary-50 tw-px-8 tw-py-7'
          )}
        >
          <Row
            title={t('cart.item.quantity')}
            value={`${count}`}
            unit={t('item.unit')}
          />
          <Row
            title={t('cart.payment.total')}
            value={`${amount.toLocaleString()}`}
            unit={t('common.label.yen')}
          />
        </ul>

        <div
          className={clsx(
            'tw-mt-7',
            'tw-flex tw-items-center tw-justify-center',
            'tw-gap-2'
          )}
        >
          <Button variant="normal" disabled={isLoading} onClick={onClose}>
            {t('favorite.modal.cancel')}
          </Button>
          <Button
            ref={addCardButtonRef}
            isLoading={isLoading}
            disabled={disabledAddCart || isLoading}
            onClick={onAddCart}
          >
            {`${t('cart.item.add')}`}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
